import iconizer from '../helpers/iconizer'

export default {
    methods: iconizer,
}
